function calculateNewValue(inputValue, action) {
    // Hier kannst du die Berechnung für den neuen Wert durchführen
    // Zum Beispiel: Verdopple den aktuellen Wert
    if (action === 'increase') {
        return inputValue; 
    } else if (action === 'decrease') {
        return Math.max(1, inputValue); 
    }
    return inputValue;
}

function checkInventory(newValue) {
    var inventoryValue = parseInt(document.getElementById('inventoryValue').textContent);
    var messageElement = document.getElementById('message');

    // Überprüfe, ob der Wert inventoryValue größer als 1 ist
    if (inventoryValue > 0) {
        var difference = Math.abs(inventoryValue - newValue); // Berechne den absoluten Wert der Differenz zwischen inventoryValue und newValue
        if (newValue > inventoryValue) {
            messageElement.innerHTML = '<p style="color: orange;"><strong>' + inventoryValue + ' Artikel liefern wir innerhalb von 2-3 Werktagen, ' + difference + ' innerhalb von 10-14 Werktage.</p>';
        } else {
            messageElement.innerHTML = '<p style="color: green;"><strong>2-3 Werktage</p>';
        }
    } else {
        // Wenn inventoryValue kleiner oder gleich 1 ist, gib eine Nachricht aus
        messageElement.innerHTML = '<p style="color: orange;"><strong>10-14 Werktage</strong></p>';
    }
}

// Event-Listener für das Mengenfeld, um Änderungen zu überwachen
var quantitySelector = document.querySelector('.quantity-selector--product');
quantitySelector.addEventListener('click', function(event) {
    var target = event.target;
    var action = target.getAttribute('data-action');

    if (action === 'increase-picker-quantity' || action === 'decrease-picker-quantity') {
        var inputElement = this.querySelector('[name="quantity"]');
        var inputValue = parseInt(inputElement.value);
        if (isNaN(inputValue)) {
            inputValue = 1; // Setze den Standardwert auf 1, wenn kein Wert eingegeben wurde
        }
        var newValue = calculateNewValue(inputValue, action.split('-')[0]);
        inputElement.value = newValue;

       // Vergleiche den neuen Wert mit dem Inventarwert und gib eine Meldung aus
        checkInventory(newValue);
    }
});

// Event-Listener für das input-Event des Eingabefelds, um Änderungen zu überwachen
var quantityInputElement = document.querySelector('[name="quantity"]');
quantityInputElement.addEventListener('input', function() {
    // Aktualisiere den Wert des Mengenfelds bei jeder Änderung
    var inputValue = parseInt(this.value);
    if (isNaN(inputValue)) {
        inputValue = 1; // Setze den Standardwert auf 1, wenn kein Wert eingegeben wurde
    }

    // Gib den neuen Wert aus
    document.getElementById('calculatedValue').textContent = 'Neuer Wert: ' + inputValue;

    // Vergleiche den neuen Wert mit dem Inventarwert und gib eine Meldung aus
    checkInventory(inputValue);
});

// Variable, um den Initialisierungsstatus zu verfolgen
var isInitialized = false;

function initializeInventory() {
    var inventorySpan = document.querySelector('.product-form__inventory');
    if (inventorySpan) {
        var inventoryText = inventorySpan.textContent.trim(); // Entferne führende und nachfolgende Leerzeichen
        var inventoryValue = inventoryText.match(/\d+/); // Extrahiere Zahlen aus dem Text
        if (inventoryValue) {
            var inventoryValueElement = document.getElementById('inventoryValue');
            if (inventoryValueElement) {
                inventoryValueElement.textContent = inventoryValue[0]; // Setze den Wert der Inventarmenge
            }
        } else {
            // Wenn kein Wert verfügbar ist, setze inventoryValue auf 0
            var inventoryValueElement = document.getElementById('inventoryValue');
            if (inventoryValueElement) {
                inventoryValueElement.textContent = '0';
            }
        }

        // Setze den Wert von calculatedValue auf 1, wenn noch nicht initialisiert
        if (!isInitialized) {
            document.getElementById('calculatedValue').textContent = 'Neuer Wert: 1';
            isInitialized = true; // Markiere die Initialisierung als abgeschlossen
        }

        // Vergleiche den neuen Wert mit dem Inventarwert und gib eine Meldung aus
        var inputValue = parseInt(quantityInputElement.value);
        if (isNaN(inputValue)) {
            inputValue = 1; // Setze den Standardwert auf 1, wenn kein Wert eingegeben wurde
        }
        checkInventory(inputValue);
    }
}

// Initialisierung beim ersten Laden der Seite
initializeInventory();

// Event-Listener für Variantenänderungen
document.addEventListener('variant:changed', function(event) {
    // Initialisierung des Inventars und der Meldungen bei Variantenänderungen
    initializeInventory();
});


/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

